'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCopy, iconCopyTag } from '@ni/nimble-components/dist/esm/icons/copy';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCopy };
export { iconCopyTag };
export const NimbleIconCopy = wrap(IconCopy);